import { render, staticRenderFns } from "./VideoDetail.vue?vue&type=template&id=8ac26ba0&scoped=true"
import script from "./VideoDetail.vue?vue&type=script&lang=js"
export * from "./VideoDetail.vue?vue&type=script&lang=js"
import style0 from "./VideoDetail.vue?vue&type=style&index=0&id=8ac26ba0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac26ba0",
  null
  
)

export default component.exports